import React from 'react';
import '../App.css';
import WelComeLayer from '../components/WelcomeLayer'
import 'bootstrap/dist/css/bootstrap.min.css';
import SignInForm from "../components/SignInForm";
import {IMAGES} from "../util/Messages";

class LoginApp extends React.Component {
  render() {
    return (
      <>
        <WelComeLayer logo={IMAGES.colsubidio} />
        <SignInForm/>
      </>
    );
  }
}

export default LoginApp;
